//@ts-nocheck
import request from '../request';
import axios from 'axios';
import globalConfig from '../../config/globalConfig';

export const getPresignedUrl = (data = {}) =>
  request.post('uploads/presign-url', data).then((res) => res);

export const uploadToBucket = (presignedImage = {}, file = {}) => {
  const url = presignedImage?.data?.presignedUrl || '';
  const apiBase = globalConfig?.axios?.apiUrl || '';
  const isBackendUrl =
    typeof url === 'string' && (url.startsWith('/') || url.startsWith(apiBase));

  // If target is our BE, send authenticated PUT with raw bytes
  if (isBackendUrl) {
    const relativeUrl = url.startsWith(apiBase)
      ? url.replace(apiBase, '')
      : url;
    return request.put(relativeUrl, file, {
      headers: {
        'Content-Type': file?.type || 'application/octet-stream',
        'Cache-Control': 'no-cache'
      }
    });
  }

  // Otherwise, assume S3 pre-signed URL upload (no credentials)
  axios.defaults.withCredentials = false;
  return axios.put(url, file, {
    headers: {
      'Content-Type': file?.type || 'multipart/form-data',
      'Cache-Control': 'no-cache'
    }
  });
};
